import { Component, OnInit, ViewChild, HostListener, ElementRef } from '@angular/core';
import { Location } from '@angular/common';
import { ssApiService } from 'app/services/ss-api.service';
import * as moment from 'moment';
import { EventRegistrationDialogComponent } from 'app/dialogs/event-registration/event-registration-dialog.component';
import { DialogService } from 'primeng/dynamicdialog';
import { GlobalServices } from 'app/services/global.service';
import { TrainingCalendarRequest } from '../../../models/ss-api/requests/training.calendar.request';
// import { Schedule } from 'primeng/primeng';
import { TrainingEvent } from '../../../models/domain/training.event';
import { TrainingClass } from '../../../models/domain/training.class';
import { MemberDesignerLicenseBasicsResponseArray } from 'app/models/ss-api/responses/member.designers.licenses.basics.response';
import { ActivatedRoute } from '@angular/router';
import dayGridPlugin from '@fullcalendar/daygrid';
import listPlugin from '@fullcalendar/list';

class CalendarEvent {
    title: string;
    start: Date;
    end: Date;
    extendedProps: {
        event: TrainingEvent
    };
}

@Component({
    selector: 'account-training-calendar',
    templateUrl: './training-calendar.component.html',
    styleUrls: ['./training-calendar.component.scss'],
    providers: [DialogService]
})

export class TrainingCalendarComponent implements OnInit {
    isBusy: boolean;
    events: Array<any> = new Array<any>();
    isLoaded = false;
    minimumVersionv2: string;
    minimumVersionv3: string;
    currentVersion: string;
    paramEventID: number;

    MyProducts: MemberDesignerLicenseBasicsResponseArray;

    @ViewChild('Calendar') Calendar: any;
    @HostListener('window:resize', ['$event']) onResize(e) {
        if (e.currentTarget.innerWidth < 1250) {
            this.Calendar.calendar.changeView('listWeek');
        } else {
            this.Calendar.calendar.changeView('dayGridMonth');
        }
    }

    calendarOptions: any = {
        plugins: [dayGridPlugin, listPlugin],
        headerToolbar: {
          left: '',
          center: 'prev,title,next',
          right: 'dayGridMonth dayGridWeek dayGridDay listWeek'
        },
        buttonText: {
            month: 'Month',
            week: 'Week',
            day: 'Day',
            list: 'List'
        },
        eventClick: (e) => {
            this.handleEventClick(e);
        },
        eventDidMount: (info) => {
            this.onEventRender(info.event, info.el);
        },
        datesSet: (dateInfo) => {
            this.loadEvents(dateInfo);
        },
    };

      constructor(private api: ssApiService, private dialogService: DialogService, private gb: GlobalServices, private route: ActivatedRoute, private location: Location) { }

    ngOnInit() {
        this.isBusy = true;
        this.calendarInit();

        this.route.paramMap.subscribe(params => {
            this.paramEventID = parseInt(params.get('id'));
        });
    }

    calendarInit() {
    }

    loadEvents(dateInfo) {
        const subscription = this.api.MemberDesignersLicensesBasics().subscribe(res => {
            // this.MyProducts = res.Data.Licenses.filter(license => license.Status == 1);
            this.MyProducts = res.Data;
            const request: TrainingCalendarRequest = new TrainingCalendarRequest();
            const tempEvents = [];
            request.StartDate = dateInfo.startStr;
            request.EndDate = dateInfo.endStr;

            const disposable = this.api.GetMemberTrainingCalendar(request).subscribe(response => {
                this.minimumVersionv2 = response.Data.TrainingMinimumSoftwareVersionv2;
                this.minimumVersionv3 = response.Data.TrainingMinimumSoftwareVersionv3;
                this.currentVersion = response.Data.CurrentSoftwareVersion;

                response.Data['TrainingEvents'].forEach((e: TrainingEvent) => {
                    const trainingClass: TrainingClass = response.Data['TrainingClasses'].filter(c => c.ID == e.TrainingClassID)[0];
                    if (this.MemberHasAnyQualifyingLicense(trainingClass)) {
                        const duration = moment(trainingClass.ClassDuration, 'hh:mm:ss');
                        const eventTemplate: CalendarEvent = new CalendarEvent();
                        eventTemplate.title = trainingClass.ClassTitle;
                        eventTemplate.start = new Date(e.EventDateTime);
                        eventTemplate.end = moment(e.EventDateTime).add({ hours: duration.hours(), minutes: duration.minutes() }).toDate();
                        eventTemplate.extendedProps = {
                            event: e
                        };
                        eventTemplate.extendedProps.event.TrainingClass = trainingClass;
                        tempEvents.push(eventTemplate);
                    }
                });

                if ((<any>window).innerWidth < 1250 && !this.isLoaded) {
                    this.Calendar.calendar.changeView('listWeek');
                } else if (!this.isLoaded) {
                    this.Calendar.calendar.changeView('dayGridMonth');
                }

                this.isLoaded = true;
                this.events = tempEvents;
                console.log(123466, this.events)
                this.isBusy = false;

                if (this.paramEventID) {
                    const event = this.events.find(item => item.event.ID == this.paramEventID);
                    if (event) {
                        this.dialogService.open(EventRegistrationDialogComponent, {
                            data: {
                                title: 'Test Title',
                                subTitle: 'Another Test',
                                event: event.event,
                                minimumVersionv2: this.minimumVersionv2,
                                minimumVersionv3: this.minimumVersionv3,
                                currentVersion: this.currentVersion
                            },
                            modal: false,
                            maskStyleClass: 'opened',
                            draggable: true,
                            keepInViewport: true
                        });
                        this.paramEventID = null;
                        this.location.replaceState('/account/training-calendar');
                    }
                }
                disposable.unsubscribe();
            });
        });
    }

    onEventRender(event, element) {
        let productHTML = '';
        let productBorder = '';

        event.extendedProps.event.TrainingClass.ProductIDs.forEach(function (product) {
            let icon = '';
            let color = '#000';
            switch (product) {
                case 2:
                    icon = '../../assets/images/icons/logo-icons-vip3d-xs.png';
                    color = '#2A66DE';
                    break;
                case 3:
                    icon = '../../assets/images/icons/logo-icons-pool-studio-xs.png';
                    color = '#F3151E';
                    break;
                case 9:
                    icon = '../../assets/images/icons/logo-icons-vizterra-xs.png';
                    color = '#64A000';
                    break;
                default:
                    return false;
            }
            productHTML += '<img class="event-software-icon" style="border-color: ' + color + '" src="' + icon + '" />';
            productBorder += '<div class="event-product-section" style="background-color: ' + color + '"></div>';
        }, this);

        element.innerHTML = '';
        if (moment(new Date(), 'YYYY-MMM-DD HH:mm A').utcOffset('-07:00').isAfter(moment(event.extendedProps.event.EventDateTime).subtract(30, 'minutes'))) {
            element.innerHTML = '<div class="disabled"><div class="event-product-border">' + productBorder + '</div><div class="event-top"><div class="event-icons">' + productHTML + '</div><h4 class="event-title">' + event.title + '</h4></div><div class="event-bottom"><p class="event-date">' + moment(event.start).format('hh:mm a') + ' - ' + moment(event.end).format('hh:mm a') + '</p></div><div class="row register-button"><button type="button" class="col-xs-12 btn btn-primary">Register For This Class</button></div></div>';
        } else {
            element.innerHTML = '<div class="event-product-border">' + productBorder + '</div><div class="event-top"><div class="event-icons">' + productHTML + '</div><h4 class="event-title">' + event.title + '</h4></div><div class="event-bottom"><p class="event-date">' + moment(event.start).format('hh:mm a') + ' - ' + moment(event.end).format('hh:mm a') + '</p></div><div class="row register-button"><button type="button" class="col-xs-12 btn btn-primary">Register For This Class</button></div>';
        }
    }

    handleEventClick(e) {
        if (moment().isBefore(moment(e.event.extendedProps.event.EventDateTime).subtract(30, 'minutes'))) {
            this.dialogService.open(EventRegistrationDialogComponent, {
                data: {
                    title: 'Test Title',
                    subTitle: 'Another Test',
                    event: e.event.extendedProps.event,
                    minimumVersionv2: this.minimumVersionv2,
                    minimumVersionv3: this.minimumVersionv3,
                    currentVersion: this.currentVersion
                },
                modal: false,
                maskStyleClass: 'opened',
                draggable: true,
                keepInViewport: true
            });
        }
    }

    MemberHasAnyQualifyingLicense(trainingClass: TrainingClass): Boolean {
        let licenseFound = false;
        var products = trainingClass.ProductIDs;
        this.MyProducts.forEach(function (product) {
            product.Keys.forEach(function (key) {
                if (key && products.indexOf(key.Product_ID) >= 0) {
                    //We have the product - do we qualify based on Min/Max versioning?
                    if (trainingClass.MinimumSoftwareVersionInt == 0 || key.SoftwareVersionInt >= trainingClass.MinimumSoftwareVersionInt){
                        if (trainingClass.MaximumSoftwareVersionInt == 0 || key.SoftwareVersionInt <= trainingClass.MaximumSoftwareVersionInt){
                            licenseFound = true;
                        }
                    }
                }
            });
        }, this);
        return licenseFound;
    }

    ProductIDForName(name: String): Number {
        if (name.indexOf('VIP3D') >= 0) {
            return 5;
        } else if (name.indexOf('Pool') >= 0) {
            return 8;
        } else if (name.indexOf('Viz') >= 0) {
            return 9;
        }
    }

}
